import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngInfo extends ngElement
{
	#owner;
	#cell;
	
	constructor () {
		super();
		this.applyBaseStyle();
	}
	
	connectedCallback() {

		const contents = this.innerHTML;
		
		this.shadowRoot.innerHTML = `
			<svg class="icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16">
				<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
				<path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
			</svg>
			
			<div class="panel">
				${contents}
			</div>
		`;

		super.connectedCallback();
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");
		this.#cell = this.closest("th,td");
		
		$("svg.icon", this.shadowRoot).on("click", e => {
			e.preventDefault();
			e.stopPropagation();

			if ($("div.panel", this.shadowRoot).is(":visible")) {
				this.#closeAll();
			}
			else {
				this.#closeAll();
				this.#open();
			}
		});
		
		$(this).on("click", e => { e.stopPropagation(); });
	};
	
	#open = () => {
		$("div.panel", this.shadowRoot).show();
		$(this.#cell).css({overflow: "visible"});
	};
	close = () => {
		$("div.panel", this.shadowRoot).hide();
		$(this.#cell).css({overflow: "unset"});
	};
	
	#closeAll = () => {
		this.#owner.body.querySelectorAll("ng-info").forEach(el => {
			var p = el.shadowRoot.querySelector("div.panel");
			if ($(p).is(":visible")) {
				$(p).hide();
				$(el.closest("th,td")).css({overflow: "unset"});
			}
		});
	};
}

if (!customElements.get('ng-info')) {
	customElements.define("ng-info", ngInfo);
}

